import { QuestionnaireAmendFlowPage } from './pages/questionnaire-amend-flow/QuestionnaireAmendFlow.page'
import { QuestionnaireFlowPage } from './pages/questionnaire-flow/QuestionnaireFlow.page'
import { QuestionnaireRootPage } from './pages/questionnaire-root/QuestionnaireRoot.page'

import type { RouteObject } from 'react-router-dom'

export const questionnaireRoutes: RouteObject[] = [
  {
    path: 'questionnaire',
    children: [
      {
        path: ':activityId',
        element: <QuestionnaireRootPage />,
        children: [
          {
            path: '',
            element: <QuestionnaireFlowPage />,
          },
        ],
      },
      {
        path: ':activityId/reconfirm',
        element: <QuestionnaireAmendFlowPage />,
      },
      {
        path: ':activityId/prefill',
        element: <QuestionnaireAmendFlowPage variant='prefill' />,
      },
    ],
  },
]
